import { isForwardMessage, type Msg } from '@halo/chat-sdk-react';
import { ForwardMinIcon } from '@halo/ui-chat-react';

export interface MsgForwardIconProps {
  message: Msg;
}

export const MsgForwardIcon = memo(function MsgForwardIcon({ message }: MsgForwardIconProps) {
  const isForwardMsg = useMemo(() => isForwardMessage(message.msg_action), [message]);

  return isForwardMsg && <ForwardMinIcon />;
});
